<template lang="pug">
  .flex-none.mt-4.pl-2(class="md:mt-12 lg:pl-0")
    img.rounded-full.w-12.h-12.-ml-2(:src="require(`../../images/${imagePath}`)" class="lg:shadow-dark md:w-16 md:h-16")

    .max-w-xs.mb-4(class='lg:max-w-sm lg:mb-8 md:ml-4')
      p.border-green-200.border.ml-6.rounded.bg-green-150.py-3.pr-3.pl-6(:class="topMargin" class="lg:py-6 lg:pr-6")
        span
          p.text-sm.text-gray-700(:class="lineHeight")
            slot
</template>

<script>
  export default {
    name: 'SwSpeechBalloon',
    props: {
      imagePath: {
        type: String,
        required: true,
      },
      topMargin: {
        type: String,
        default: '-mt-6',
      },
    },
    computed: {
      lineHeight () {
        return this.$screen.md ? 'leading-snug' : 'leading-tight';
      },
    },
  };
</script>
